import { BONDS_STORE_NAME } from '@/creditflowresearch/application/Bonds/constants';
import Status from '@framework/ui/Organisms/Filters/FiltersPanel/Status/Status';
import { useFiltersContext } from '@framework/ui/Organisms/Filters/FiltersContext';

const filterName = 'includedStatus';

const StatusContainer = (props) => {
  const { getFiltersByFilterName } = useFiltersContext();
  const selectedValue = getFiltersByFilterName(BONDS_STORE_NAME, filterName) || '';

  return (
    <Status
      { ...props }
      filterName={ filterName }
      selectedValue={ selectedValue }
    />
  );
};

export default StatusContainer;
